import cc from 'classcat';
import { capitalizeFirst } from 'ramda-extension';

import BaseComposableCallout from '#src/rows/ComposableCallout/index.js';

import styles from './ComposableCallout.scss';

export default function ComposableCallout(props) {
  return (
    <BaseComposableCallout
      className={cc([
        styles.container,
        styles[`bg${capitalizeFirst(props.backgroundColor)}`],
      ])}
      {...props}
    />
  );
}
